// API 配置
// 前后端在同一端口，使用相对路径
const API_BASE_URL = '';

console.log('API Base URL:', API_BASE_URL || '(相对路径)');

export default API_BASE_URL;
